<template>
	<div v-if="user" id="profile" class="profileContainer">
    <button class="btn backBtn" @click="$router.push({ path: '/' })"><i class="icon-left-open"></i></button>
    <div class="iconContainer">
      <i class="icon-user"></i>
    </div>
    <div class="card">
      <div class="cardHeader">
        <div class="cardHeader_details">
          <span class="cardHeader_name">{{ user.name }}</span>
          <span class="cardHeader_email">{{ user.email }}</span>
        </div>
        <button class="button cardHeader_button" @click="logout">LOGOUT</button>
      </div>
      <div class="cardBody region">
        <label class="label region_select-label" for="region_select">
          Default Region:
          <select class="select region_select-option" id="region_select" v-model="user.profile.weather_region_id" @change="updateProfile()">
            <option v-for="region in regions" v-bind:value="region.id" v-bind:key="region.id">{{region.name}}</option>
          </select>
        </label>

        <div class="select_container">
          <span class="select_container-label">Dark Mode</span>
          <label class="switch">
            <input type="checkbox" v-model=user.profile.dark_mode @change="updateProfile()">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="cardHeader thin">
        <i class="icon-bell notificationIcon"></i>
        <h3>NOTIFICATIONS</h3>
      </div>
      <div class="cardBody region">
        <div class="select_container">
          <span class="select_container-label">High Rainfall</span>
          <label class="switch">
            <input type="checkbox" v-model=user.profile.notification_high_rainfall @change="updateProfile()">
            <span class="slider round"></span>
          </label>
        </div>
        <hr>
        <div class="select_container">
          <span class="select_container-label">Daily Weather Update</span>
          <label class="switch">
            <input type="checkbox" v-model=user.profile.notification_daily_weather_update @change="updateProfile()">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="cardHeader thin">
        <i class="icon-pencil notificationIcon"></i>
        <h3>UNITS</h3>
      </div>
      <div class="cardBody region">
        <div class="select_container">
          <span class="select_container-label">Wind</span>
          <div class="btnGroup">
            <button
            :class="{ active: user.profile.unit_wind == 'km/h' }"
            @click="updateUnitWind('km/h')"
            type="button"
            class="buttonGroupLeft"
            >km/h</button>
            <button
            :class="{ active: user.profile.unit_wind == 'kn' }"
            @click="updateUnitWind('kn')"
            type="button"
            class="buttonGroupRight"
            >kn</button>
          </div>
        </div>
        <hr>
        <div class="select_container">
          <span class="select_container-label">Temperature</span>
          <div id="tempButtons" class="btnGroup">
            <button
            :class="{ active: user.profile.unit_temperature == 'C' }"
            @click="updateUnitTemperature('C')"
            type="button"
            class="buttonGroupLeft"
            >&#8451;</button>
            <button
            :class="{ active: user.profile.unit_temperature == 'F' }"
            @click="updateUnitTemperature('F')"
            type="button"
            class="buttonGroupRight"
            >&#8457;</button>
          </div>
        </div>
      </div>
      <div class="cardHeader thin">
        <i class="icon-user notificationIcon"></i>
        <h3>INTERESTS</h3>
      </div>
      <interest-card></interest-card>
      <footer>
        <p><small>The eThekwini Municipality will not be held responsible for any changes, omissions or inaccuracies contained herein which may result in unforeseen expense, injury or other misfortune.</small></p>
      </footer>
    </div>
  </div>
</template>

<script>
    import InterestCard from '../cards/Interests'
    import { mapMutations, mapActions } from 'vuex'
    export default {
      name: 'profile-card',
      components: {
        InterestCard
      },
      props: {
        user: Object,
        regions: Array
      },
      data: function () {
        return {
        }
      },
      watch: {
      },
      computed: {
      },
      methods: {
        updateUnitWind: function (v) {
          this.user.profile.unit_wind = v
          this.updateProfile()
        },
        updateUnitTemperature: function (v) {
          this.user.profile.unit_temperature = v
          this.updateProfile()
        },
        updateProfile: function () {
          document.getElementById('app').classList.add('loading')
          let updateProfile = {
            name: this.user.name,
            weather_region_id: this.user.profile.weather_region_id,
            dark_mode: this.user.profile.dark_mode,
            notification_high_rainfall: this.user.profile.notification_high_rainfall,
            notification_daily_weather_update: this.user.profile.notification_daily_weather_update,
            unit_wind: this.user.profile.unit_wind,
            unit_temperature: this.user.profile.unit_temperature
          }
          this.updateUserInfo(updateProfile)
            .then((response) => {
              if (this.user.profile.notification_daily_weather_update === 1 || this.user.profile.notification_high_rainfall === 1) {
                this.oneSignalNotificationUpdate()
              }
              document.getElementById('app').classList.remove('loading')
              window.alertify.dismissAll()
              window.alertify.success('Settings Saved.')
            })
        },
        oneSignalNotificationUpdate: function () {
          let OneSignal = window.OneSignal
          OneSignal.push(() => {
            OneSignal.registerForPushNotifications()
            OneSignal.setSubscription(true).then(() => {
              OneSignal.getUserId((userId) => {
                this.$axios.post('/auth/notificationuserid', {
                  key: userId
                })
              })
            })
          })
        },
        updateInterests: function () {

        },
        logout: function () {
          this.removeJWT()
          this.$router.push('/')
        },
        ...mapMutations([
          'removeJWT'
        ]),
        ...mapActions([
          'updateUserInfo'
        ])
      }
    }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue